import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import ReactMarkdown from "react-markdown";
import { Container, Row } from "react-bootstrap";

import ExerciseWon from "../../../../image/happy-azeto.svg";
import ExerciseLose from "../../../../image/sad-azeto.svg";

import { showDangerAlert } from "../../../../redux/actions/alert/alertActions";
import { startFetchingQuiz } from "../../../../redux/actions/singleSimDetail/singleSimDetailAction";
import userMessageType from "../../../../redux/actions/userMessage/userMessageType";

import scrollToTop from "../../../../libs/scrollToTop";

import ButtonComponent from "../../button";

import { QuizTabWrapper } from "./styledQuizTab";

const QuizTab = ({ simID, quizData, postQuizRequest }) => {
  const { quizPostIsLoading, quizPostError, runPostQuiz } = postQuizRequest;
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();
  //exam
  const [isExamed, setIsExamed] = useState(false);
  const [examResultSubmited, setExamResultSubmited] = useState([]);
  const [examPercentSubmited, setExamPercentSubmited] = useState("");
  const [examMessageSubmited, setExamMessageSubmited] = useState("");

  const examBullet = ["الف", "ب", "ج", "د"];
  const handleSubmitExam = (formValues) => {
    let formValuesArray = [];
    for (let key in formValues) {
      console.log(formValues[key]);
      if (!formValues[key]) {
        dispatch(showDangerAlert("لطفا به تمام سوال‌ها پاسخ دهید."));
        return;
      } else {
        const QId = key;
        const AId = formValues[key];
        formValuesArray.push({ question: `${QId}`, answer: `${AId}` });
      }
    }

    const data = {
      examdata_set: formValuesArray,
    };
    runPostQuiz(data)
      .then((response) => {
        handleCheckedExam(response.data.question_correction);
        setExamResultSubmited(response.data.question_correction);
        setExamPercentSubmited(response.data.percent);
        setExamMessageSubmited(response.data.message);
        setIsExamed(true);
        dispatch({ type: userMessageType.UPDATE_COUNT_UNREAD_MESSAGE });
      })
      .catch((error) => {
        console.log(error.response);
        dispatch(
          showDangerAlert("متاسفانه اتفاقی افتاده. لطفا بعدا دوباره امتحان کنید.")
        );
        return;
      });
  };

  const handleCheckedExam = (e) => {
    e.map((item) => {
      if (item.is_true === true) {
        document.getElementById(item.question).classList.add("check-is-true-exam");
        document
          .getElementById(item.question)
          .classList.remove("check-is-false-exam");
      } else {
        document.getElementById(item.question).classList.add("check-is-false-exam");
        document
          .getElementById(item.question)
          .classList.remove("check-is-true-exam");
      }
    });
  };

  const handleRedoExam = (e) => {
    e.preventDefault();
    dispatch(startFetchingQuiz(simID));
    {
      examResultSubmited.map((item) => {
        document
          .getElementById(item.question)
          .classList.remove("check-is-false-exam");
        document
          .getElementById(item.question)
          .classList.remove("check-is-true-exam");
      });
    }
    scrollToTop();
    setIsExamed(false);
  };

  return (
    <QuizTabWrapper className="bg-white">
      <form onSubmit={handleSubmit(handleSubmitExam)} className="py-4 px-md-4 px-2">
        <ol className="ps-2">
          {quizData.results.map((item, index) => {
            return (
              <div className="question-container" key={item.id} id={item.id}>
                <li>
                  <ReactMarkdown>{item.title}</ReactMarkdown>
                </li>

                <Row className="justify-content-between container-answer m-0">
                  <ul
                    className={
                      item.image ? "list-unstyled col-12 col-md-8" : "list-unstyled"
                    }
                  >
                    {item.answer_set.map((qitem, qindex) => {
                      return (
                        <div
                          key={qitem.id}
                          className={
                            qitem.image
                              ? "col-xs-12 col-sm-6 d-inline-block quiz-answer-container"
                              : "quiz-answer-container"
                          }
                        >
                          <label htmlFor={qitem.id} className="label-exam d-grid">
                            <input
                              type="radio"
                              id={qitem.id}
                              {...register(`${item.id}`)}
                              value={qitem.id}
                              disabled={isExamed}
                              data-is-true={qitem.is_true ? "Y" : "N"}
                              className="input-exam d-none"
                            />
                            <span className="exam-bullet rounded-circle">
                              {examBullet[qindex]}
                            </span>
                            {qitem.image ? (
                              <img id={qitem.id} src={qitem.image} width="150" />
                            ) : (
                              <ReactMarkdown>{qitem.title}</ReactMarkdown>
                            )}
                          </label>
                        </div>
                      );
                    })}
                  </ul>
                  {item.image && (
                    <img
                      src={item.image}
                      alt={`question-${index}`}
                      className="col-12 col-sm-8 col-md-4 img-fluid"
                    />
                  )}
                </Row>
              </div>
            );
          })}
        </ol>
        {!quizPostError ? (
          <div className="text-center mt-4">
            {isExamed ? (
              <ButtonComponent className="px-4" onClick={handleRedoExam}>
                شرکت مجدد در آزمون
              </ButtonComponent>
            ) : (
              <>
                {quizData.results.length == 0 ? (
                  <p>لطفا دوباره امتحان کنید !</p>
                ) : (
                  <>
                    {quizPostIsLoading ? (
                      <span>درحال ثبت پاسخ...</span>
                    ) : (
                      <ButtonComponent type="submit" className="px-5">
                        ثبت پاسخ
                      </ButtonComponent>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        ) : (
          <p className="text-center mt-4">{quizPostError}</p>
        )}
      </form>
      {isExamed && (
        <Container className="py-4">
          <div className="d-flex justify-content-around align-items-center text-primary">
            <div className="fs-3">
              <b className="text-center">نتیجه آزمون</b>
              <p>
                درصد شما از این آزمون :<u>%{examPercentSubmited}</u>
              </p>
            </div>
            <div className="d-flex flex-column align-items-center">
              {examPercentSubmited > 50 ? (
                <img className="img-fluid" src={ExerciseWon} alt="برد" width="120" />
              ) : (
                <img
                  className="img-fluid"
                  src={ExerciseLose}
                  alt="باخت"
                  width="120"
                />
              )}
              <p>{examMessageSubmited}</p>
            </div>
          </div>
        </Container>
      )}
    </QuizTabWrapper>
  );
};

export default QuizTab;
